import React, { Suspense } from 'react';
import { Loader } from 'freemium-ui';
import { Center } from 'shared/globals';
import SurveyList from '../screens/survey/list';
import {
  GoToRouteType,
  HostConfigType,
  SetBreadcrumbDataType,
} from 'shared/types';
import { defaultGoToRoute } from 'shared/utils';

const Loading = () => (
  <Center minHeight="calc(100vh - 100px)">
    <Loader />
  </Center>
);

export type ListProps = {
  goToRoute?: GoToRouteType;
  role?: any;
  setBreadcrumpData?: SetBreadcrumbDataType;
  hostConfig: HostConfigType;
};

export const List = ({
  role,
  goToRoute = defaultGoToRoute,
  hostConfig,
  setBreadcrumpData,
}: ListProps) => {
  return (
    <Suspense fallback={<Loading />}>
      <SurveyList
        setBreadcrumbData={setBreadcrumpData}
        role={role}
        goToRoute={goToRoute}
        hostConfig={hostConfig}
      />
    </Suspense>
  );
};

export default List;
